import './Account.css';
import { Button, Container } from 'react-bootstrap';
import { useRef } from 'react';

function Account(){

    const email = useRef();
    const password = useRef();

    return(
        <Container>
            <div className="account">
                <h3>LOGIN</h3>
                <p>Please enter your e-mail and password:</p>
                <div className="input">
                    <input type="text" id="email" name="email" placeholder="Email" ref={email}/>
                    <div className="password">
                        <input type="password" id="password" name="password" placeholder="Password" ref={password} />
                        <button className="forgot">Forgot password?</button>
                    </div>
                    <Button variant="outline-dark" className="login" onClick={() => {

                        var reg1 = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
                        var em = email.current.value;

                        var reg2 = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
                        var pw = password.current.value;

                        if (false === reg1.test(em)) {
                            alert('Enter your email.');
                            return false;
                        } else if (false === reg2.test(pw)) {    
                            alert('Password must be at least 8 characters long and must contain all numeric, uppercase, lowercase, and special characters.');
                            return false;
                        } else {
                            alert('pass');
                            return true;
                        }

                    }}>LOGIN</Button>{' '}
                </div>
                <span>Don't have an account?</span>
                <a href="#">Create one</a>
            </div>
        </Container>
    )

}


export default Account;